export default function help (context, args, flags) {
  if (args.length === 0 && flags.length === 0) {
    return `
<table class="help-table">
  <tr>
    <td><u>help</u> [command]</td>
    <td>explains how to use a command</td>
  </tr>
  <tr>
    <td><u>clear</u></td>
    <td>clears the terminal</td>
  </tr>
  <tr>
    <td><u>ls</u></td>
    <td>lists files and directories in the working directory</td>
  </tr>
  <tr>
    <td><u>cd</u> [directory]</td>
    <td>changes the working directory to the one passed</td>
  </tr>
  <tr>
    <td><u>read</u></td>
    <td>prints the contents of a text file</td>
  </tr>
  <tr>
    <td><u>login</u></td>
    <td>wip. logs in to your account using your credentials</td>
  </tr>
  <tr>
    <td><u>logout</u></td>
    <td>wip. logs out of your account</td>
  </tr>
</table>    
    `
  }
}



// WEBPACK FOOTER //
// ./src/natos/commands/help.js